// @ts-expect-error TS7016
import Utils from "@/legacy/Utils";
import {AlertExtraDataJSON} from "@/lib/types/alerting.ts";
import {TxnNetworkResult, TxnResult} from "@/lib/types/transaction.ts";

export const aggregateResults = (data?: AlertExtraDataJSON, version: string = "2.0.0"): TxnResult[] => {
  let results = data?.results || [];
  if (!data) {
    return results;
  }

  const network = data.network;
  if (network) {
    const firstStepIndex = Utils.isVersionGreaterOrEqual(version, "3.0.1") ? 0 : 1;
    results = results.map((_, index) => {
      const requests = network
        .filter((item) => item.step === index + firstStepIndex)
        .sort((a, b) => a.timing.requestWillBeSent - b.timing.requestWillBeSent);

      return {
        ...results[index],
        requests: requests,
      };
    });
  }

  return results;
};

export const getNetworkRequests = (network: TxnNetworkResult[], step: number): TxnNetworkResult[] => {
  return network
    .filter((item) => item.step === step)
    .sort((a, b) => a.timing.requestWillBeSent - b.timing.requestWillBeSent);
};
